import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { AbnInputComponent } from './components/abn';
import { ActivityIconComponent } from './components/activity-icon/activity-icon.component';
import { AddressDisplayComponent, AddressInputComponent } from './components/address';
import { CloseModalComponent, EscalateLegalReviewModalComponent, DefaultProcessComponent } from './components/debts';
import { LoginFormComponent } from './components/auth';
import { CalendarComponent } from './components/calendar/calendar.component';
import { CircularProgressComponent } from './components/circular-progress/circular-progress.component';
import { CurrencyComponent } from './components/currency/currency.component';
import { DropAreaComponent } from './components/attachments';
import { AddressModalComponent, ContactFormComponent, EmailModalComponent, PhoneModalComponent } from './components/contacts';
import { NoteFormComponent, NoteListComponent, NoteUpdateModalComponent, UploadModalComponent } from './components/notes';
import { UploadImportsModalComponent } from './components/imports';
import {
  ActivityTextPipe,
  DebtNumberPipe,
  DiffInDaysPipe,
  FirstLetterUppercasePipe,
  FrequencyTextPipe,
  LevelTextPipe,
  PaymentMethodTextPipe,
  PhoneNumberPipe,
  PhoneTypePipe,
  StatusColorPipe,
  HighlightActivityPipe,
  centsToDollarsPipe,
  dollarsToCentsPipe
} from './pipes';
import { DropdownComponent, DropdownButtonComponent, DropdownContentComponent } from './components/dropdown';
import { FiduciariesComponent, FiduciaryModalComponent } from './components/fiduciaries';
import { InvoiceFormComponent } from './components/invoices';
import { OffersComponent } from './components/plans';
import { ModalComponent } from './components/modal/modal.component';
import { PaginatedTableComponent } from './components/pagination';
import {
  CreditCardFormComponent,
  DirectDebitFormComponent,
  InstantPaymentComponent,
  SharedInstantPaymentModalComponent
} from './components/payments';
import { SelectComponent } from './components/select/select.component';
import { SliderComponent } from './components/slider/slider.component';
import { Window } from './injectable/window';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  providers: [Window],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    AbnInputComponent,
    ActivityIconComponent,
    ActivityTextPipe,
    AddressDisplayComponent,
    AddressInputComponent,
    CalendarComponent,
    CircularProgressComponent,
    CloseModalComponent,
    CreditCardFormComponent,
    CurrencyComponent,
    DebtNumberPipe,
    DiffInDaysPipe,
    DirectDebitFormComponent,
    InstantPaymentComponent,
    SharedInstantPaymentModalComponent,
    EscalateLegalReviewModalComponent,
    DefaultProcessComponent,
    PaymentMethodTextPipe,
    SliderComponent,
    DropdownButtonComponent,
    DropdownComponent,
    DropdownContentComponent,
    FiduciariesComponent,
    FiduciaryModalComponent,
    FirstLetterUppercasePipe,
    FrequencyTextPipe,
    HighlightActivityPipe,
    centsToDollarsPipe,
    dollarsToCentsPipe,
    InvoiceFormComponent,
    LevelTextPipe,
    LoginFormComponent,
    ModalComponent,
    PaginatedTableComponent,
    SelectComponent,
    StatusColorPipe,
    AddressModalComponent, ContactFormComponent, EmailModalComponent, PhoneModalComponent,
    NoteFormComponent, NoteListComponent, NoteUpdateModalComponent, UploadModalComponent,
    UploadImportsModalComponent,
    DropAreaComponent,
    OffersComponent,
    PhoneNumberPipe,
    PhoneTypePipe,
  ],
  declarations: [
    AbnInputComponent,
    ActivityIconComponent,
    ActivityTextPipe,
    AddressDisplayComponent,
    AddressInputComponent,
    CalendarComponent,
    CircularProgressComponent,
    CloseModalComponent,
    CreditCardFormComponent,
    CurrencyComponent,
    DebtNumberPipe,
    DiffInDaysPipe,
    DirectDebitFormComponent,
    InstantPaymentComponent,
    SharedInstantPaymentModalComponent,
    EscalateLegalReviewModalComponent,
    DefaultProcessComponent,
    PaymentMethodTextPipe,
    SliderComponent,
    DropdownButtonComponent,
    DropdownComponent,
    DropdownContentComponent,
    FiduciariesComponent,
    FiduciaryModalComponent,
    FirstLetterUppercasePipe,
    FrequencyTextPipe,
    HighlightActivityPipe,
    centsToDollarsPipe,
    dollarsToCentsPipe,
    InvoiceFormComponent,
    LevelTextPipe,
    LoginFormComponent,
    ModalComponent,
    PaginatedTableComponent,
    SelectComponent,
    StatusColorPipe,
    AddressModalComponent, ContactFormComponent, EmailModalComponent, PhoneModalComponent,
    NoteFormComponent, NoteListComponent, NoteUpdateModalComponent, UploadModalComponent,
    UploadImportsModalComponent,
    DropAreaComponent,
    OffersComponent,
    PhoneNumberPipe,
    PhoneTypePipe,
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts